var React = require('react');

function To (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt"},[React.createElement("path",{"fill":"#c10000","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M0 0h250v200.3H0z","key":1}),React.createElement("g",{"fill":"#c10000","key":2},[React.createElement("path",{"d":"M102.8 31.2h39.9v139.6h-39.8z","key":0}),React.createElement("path",{"d":"M192.6 81v40H53V81z","key":1})])]));
}

To.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = To;

To.default = To;
